import { Avatar, IconButton } from "@mui/material";
import { setEsgComplianceSelectedTask } from "actions/task/esgCompliance/esgComplianceTaskAction";
import { useSelector } from "react-redux";
import { LuX } from "react-icons/lu";

// const rowData = {
//   assessment_id: "6931703d9f08c90113fa23a6",
//   assessment_name: "CHECK",
//   year_of_assessment: "2024-2025",
//   framework_id: "68f73e1a709f4083b3c45045",
//   template_type: "template_1",
//   assigned_as: ["APPROVER"],
// };
const ThreadToast = ({
  avatar,
  username,
  message,
  navigate,
  dispatch,
  rowData,
  sender,
  redirect,
  onClose,
}) => {
  
  const { isLoggedin } = useSelector((state) => state.user);
  
  return (
    <div
      style={{ display: "flex", gap: "12px", alignItems: "flex-start", position: "relative" }}
      // onClick={() => {
      //    dispatch(setEsgComplianceSelectedTask(rowData));
      //   setTimeout(() => {
      //     navigate(
      //       // `/task/ESG_Compliance/${rowData.assessment_name.replaceAll(" ", "_")}`,
      //       redirect,
      //       {
      //         // state: {
      //         //   autoClickMetric: "68ff5f50e16fe8504dc30024",
      //         //   autoClickType: "CHAT",
      //         // },
      //       }
      //     );
      //   }, 0);
      // }}
      onClick={() => {
        // DataHub KPI_ROLLUP notifications - redirect to Data Sets tab in DataHub module
        if (sender?.specialParam === "KPI_ROLLUP") {
          navigate("/data_hub", {
            state: {
              dataHubTab: 4, // Data Sets tab index
            },
          });
          return;
        }

        // DataHub KPI notifications
        // if (
        //   sender?.specialParam?.startsWith("KPI_") ||
        //   sender?.specialParam === "KPI_USER" ||
        //   sender?.specialParam === "KPI_REMINDER"
        // ) {
        //   // Navigate to task listing page with auto-open data
        //   navigate(rowData?.redirect || `/task/Datahub_KPI_Survey`, {
        //     state: {
        //       survey_id: rowData?.survey_id,
        //       assigned_as: rowData?.assigned_as,
        //       autoOpenSurvey: true,
        //     },
        //   });
        //   return;
        // }

        // ESG Compliance (existing)
        // if (sender?.specialParam === "TASK_USER") {
        //   console.log("inside task user");
        //   navigate("/task/ESG_Compliance", {
        //     state: {
        //       autoOpenTaskId: rowData?.assessment_id,
        //       autoClickMetric: rowData?.question_id,
        //       autoClickType: rowData?.redirect,
        //     },
        //   });
        // } else {
        //   navigate(
        //     `/esg_compliance/${rowData.assessment_name.replaceAll(" ", "_")}`,
        //     {
        //       state: {
        //         autoOpenQuestion: rowData?.question_id,
        //         autoClickType: rowData?.redirect,
        //         autoClickMetric: rowData?.question_id,
        //         assessment_id: rowData?.assessment_id,
        //       },
        //     }
        //   );
        // }
        navigate(redirect);
      }}
    >
      <Avatar
        src={
          "https://impactgrows-backup.s3.ap-south-1.amazonaws.com/defaul-images/Stirrup_S_Logo.jpeg"
        }
        alt={username}
        sx={{
          width: 40,
          height: 40,
          bgcolor: "#1976d2",
        }}
      >
        {!avatar && username}
      </Avatar>

      <div style={{ flex: 1 }}>
        <div
          style={{
            fontWeight: 600,
            fontSize: "14px",
            marginBottom: 2,
          }}
        >
          {username}
        </div>

        <div
          style={{ fontSize: "13px", lineHeight: 1.4 }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>

      {/* Close button */}
      {onClose && (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation(); // Prevent redirect when clicking close
            onClose();
          }}
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            color: "#666",
          }}
        >
          <LuX size={16} />
        </IconButton>
      )}
    </div>
  );
};

export default ThreadToast;
